import * as methods from './methods';

export interface MessageBase {
  id: number | string;
}

export interface MessageRequest extends MessageBase {
  method: string;
  params?: Record<string, any>;
}

export interface MessageResponse extends MessageBase {
  result: any;
}

export interface MessageErrorResponse extends MessageBase {
  error: any;
}

export function register(iframe: HTMLIFrameElement) {
  const { contentWindow } = iframe;
  if (!contentWindow) return;

  const origin = new URL(iframe.src).origin;

  function resolve(id: MessageBase['id'], result: any) {
    contentWindow!.postMessage(
      {
        id,
        result,
      },
      origin
    );
  }

  function reject(id: MessageBase['id'], error: any) {
    contentWindow!.postMessage(
      {
        id,
        error,
      },
      origin
    );
  }

  async function handleMessage(event: MessageEvent) {
    const { data, origin: origin_ } = event;

    if (origin_ === origin && data?.id && data?.method && contentWindow) {
      const method = methods[data.method as keyof typeof methods];

      try {
        if (!method) {
          throw new Error('Method not found');
        }
        // @ts-expect-error params
        const result = await method(data.params);
        resolve(data.id, result);
      } catch (error) {
        reject(data.id, error);
      }
    }
  }

  window.addEventListener('message', handleMessage);

  return () => {
    window.removeEventListener('message', handleMessage);
  };
}
